import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton, type IIconButtonProps } from 'shared/ui'
import { ZIndex } from 'shared/constants/zIndex'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import styles from './styles.module.scss'

export const CallRecordPopUpButton: FC<Partial<IIconButtonProps>> = observer((props) => {
  const store = useCallPopUpDefaultContext()
  const { organizationStore } = useEntitiesContext()
  const {
    isRecord,
    isRecordDisabled,
    handleRecord,
    innerRefTooltipCurrent,
    callRecordPopUpButtonTooltipLabel,
  } = store

  return (
    <div className={styles.wrap}>
      <IconButton
        size={'large'}
        color={'red'}
        variant={'custom'}
        active={isRecord}
        disabled={isRecordDisabled}
        ariaLabel={`CallRecordPopUpButton_${isRecord ? 'stop' : 'record'}`}
        onClick={() => {
          if (organizationStore.isEnabledOrganisationCallAutoRecord) return
          handleRecord('toggle')
        }}
        iconProps={{
          icon: 'record',
          animation: isRecord,
        }}
        tooltipProps={{
          zIndex: ZIndex.OVERLAY_TOP_1,
          label: callRecordPopUpButtonTooltipLabel,
          placement: 'top',
          PopperProps: {
            popperOptions: {
              modifiers: [
                {
                  name: 'preventOverflow',
                  options: {
                    boundary: innerRefTooltipCurrent,
                  },
                },
              ],
            },
          },
        }}
        {...props}
      />
    </div>
  )
})
